import { useCallback, useEffect, useState } from "react";
import { Eye } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError, formatData, openPdf } from "@/lib/api";
import { PageHeader } from "@/components/dashboard/PageHeader";
import { ReportForm } from "@/components/dashboard/ReportForm";
import { ReportStatusBadge } from "@/components/dashboard/StatusBadge";

export function ReportsPanel() {
  const [reports, setReports] = useState([]);
  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/reports");
      setReports(data);
    } catch (err) {
      toast.error(formatApiError(err));
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const view = (id) => openPdf(id).catch((err) => toast.error(formatApiError(err)));

  return (
    <div>
      <PageHeader eyebrow="Solo Atti Giudiziari" title="Nuova segnalazione di sfratto" text="Le segnalazioni sono accettate solo con il PDF della convalida di sfratto. Diventano consultabili solo dopo la verifica del documento." />
      <div className="grid gap-8 xl:grid-cols-[1.3fr_1fr]">
        <ReportForm onCreated={load} />
        <section className="surface p-6" data-testid="my-reports-list">
          <h2 className="text-lg font-semibold text-[#0f172a]">Le mie segnalazioni</h2>
          <ul className="mt-5 space-y-3">
            {reports.length === 0 && <li className="rounded-xl border border-dashed border-slate-300 p-6 text-center text-sm text-slate-500">Nessuna segnalazione inviata.</li>}
            {reports.map((r) => (
              <li key={r.id} data-testid={`report-item-${r.id}`} className="rounded-xl border border-slate-200 p-4">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <p className="font-semibold text-[#0f172a]">{r.nome} {r.cognome}</p>
                    <p className="text-xs text-slate-500">{r.tribunale} · R.G. {r.numero_rg} · {formatData(r.data_convalida)}</p>
                  </div>
                  <ReportStatusBadge status={r.status} testid={`report-status-${r.id}`} />
                </div>
                {r.note_verifica && <p className="mt-2 text-xs text-slate-600">Nota: {r.note_verifica}</p>}
                <button data-testid={`button-view-pdf-${r.id}`} onClick={() => view(r.id)} className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-[#2563eb] hover:text-[#1e3a8a]"><Eye className="h-3.5 w-3.5" />Visualizza PDF</button>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
}
